import React from "react"

export const BulletPointIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
        <path d="M4.4375 4H13.4375" stroke="#191345" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.4375 8H13.4375" stroke="#191345" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.4375 12H13.4375" stroke="#191345" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M1.3125 3.9375C1.3125 4.28268 1.59232 4.5625 1.9375 4.5625C2.28268 4.5625 2.5625 4.28268 2.5625 3.9375C2.5625 3.59232 2.28268 3.3125 1.9375 3.3125C1.59232 3.3125 1.3125 3.59232 1.3125 3.9375Z"
            fill="#191345"
        />
        <path
            d="M1.3125 8C1.3125 8.34518 1.59232 8.625 1.9375 8.625C2.28268 8.625 2.5625 8.34518 2.5625 8C2.5625 7.65482 2.28268 7.375 1.9375 7.375C1.59232 7.375 1.3125 7.65482 1.3125 8Z"
            fill="#191345"
        />
        <path
            d="M1.3125 12.0625C1.3125 12.4077 1.59232 12.6875 1.9375 12.6875C2.28268 12.6875 2.5625 12.4077 2.5625 12.0625C2.5625 11.7173 2.28268 11.4375 1.9375 11.4375C1.59232 11.4375 1.3125 11.7173 1.3125 12.0625Z"
            fill="#191345"
        />
    </svg>
)
